
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/palvelut/ui-ux-suunnittelu",
      function () {
        return require("private-next-pages/palvelut/ui-ux-suunnittelu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/palvelut/ui-ux-suunnittelu"])
      });
    }
  